import { DefaultValues } from 'react-hook-form'
import { array, boolean, InferType, lazy, object } from 'yup'

import { claimsModalSchema } from './components/ClaimsField/AddClaimModalForm'
import { convictionsModalSchema } from './components/ConvictionsField/AddConvictionForm'
import { requiredMessage } from 'directFlow/state/config/content'
import { Page } from 'directFlow/types'

export const historyDefaultValues = {
  hasInternationalNcd: undefined,
  claims: {
    checked: undefined,
    list: [],
  },
  convictions: {
    checked: undefined,
    list: [],
  },
  nonMotoringConvictions: undefined,
  anyDriverPreviousInsuranceCancelled: undefined,
} satisfies DefaultValues<HistorySchemaType>

export const getHistorySchema = ({
  showPreviousInsuranceCancelled,
}: {
  showPreviousInsuranceCancelled: boolean | undefined
}) =>
  object({
    hasInternationalNcd: boolean().when([`$${Page.LICENCE}.countryOfFirstTest`], {
      is: (countryOfFirstTest: string) => countryOfFirstTest === 'GB' || !countryOfFirstTest,
      then: () => boolean().nullable().optional(),
      otherwise: () => boolean().required(requiredMessage).nullable(),
    }),
    claims: object({
      checked: boolean().nullable().required(requiredMessage),
      list: array()
        .of(lazy(() => claimsModalSchema))
        .when('checked', {
          is: true,
          then: (schema) => schema.min(1, 'Please add at least one item or select "No"'),
          otherwise: (schema) => schema.optional().default([]),
        })
        .optional()
        .default([]),
    }),
    convictions: object({
      checked: boolean().nullable().required(requiredMessage),
      list: array()
        .of(lazy(() => convictionsModalSchema))
        .when('checked', {
          is: true,
          then: (schema) => schema.min(1, 'Please add at least one item or select "No"'),
          otherwise: (schema) => schema.optional().default([]),
        })
        .optional()
        .default([]),
    }),
    nonMotoringConvictions: boolean().required(requiredMessage),

    ...(!showPreviousInsuranceCancelled
      ? {
          anyDriverPreviousInsuranceCancelled: boolean().required(requiredMessage),
        }
      : { anyDriverPreviousInsuranceCancelled: boolean().optional() }),
  })

export type HistorySchemaType = InferType<ReturnType<typeof getHistorySchema>>
